import { useTranslationWithPrefix } from '@hotjar/translations';

interface UseModalTitle {
  isLoading: boolean;
  title: string;
}

interface Props {
  isLoading: boolean;
  days: number;
  coveragePercentage: number;
  isError: boolean;
}

export const useModalTitle = ({
  isLoading,
  days,
  coveragePercentage,
  isError,
}: Props): UseModalTitle => {
  const { t } = useTranslationWithPrefix('revenue:traffic-recommendation-modal');

  if (isError) {
    return {
      isLoading: false,
      title: t('title-error'),
    };
  }

  if (isLoading) {
    return {
      isLoading: true,
      title: '',
    };
  }

  let title;
  if (days === 0) {
    title = t('title-0-days');
  } else if (coveragePercentage === 100) {
    title = t('title-100-coverage');
  } else {
    title = t('title', {
      missingCoveragePercentage: 100 - coveragePercentage,
    });
  }

  return {
    isLoading,
    title,
  };
};
